import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]




export default /*@__PURE__*/_defineComponent({
  __name: 'IconBack',
  props: {
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: `${__props.size}px`,
    height: `${__props.size}px`,
    viewBox: `0 0 512 512`,
    xmlns: "http://www.w3.org/2000/svg"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("polygon", {
      fill: "currentColor",
      points: "352,128.4 319.7,96 160,256 160,256 160,256 319.7,416 352,383.6 224.7,256 "
    }, null, -1)
  ]))], 8, _hoisted_1))
}
}

})